import { cap } from '../../../State'
import { translations } from '../../../translations'
import { LABEL_STATISTICS } from '../constants'
import { DetailsErrorHandled } from '../DetailsErrorHandled'
import StatisticsCard from '../StatisticsCard'

const language = cap.language.state || 'IT'
const t = translations[language] || translations.IT

/**
 * Griglia delle tre card di dettaglio: elaborate, inoltrate, errori/escluse.
 * @param {Object} props
 * @param {Object} props.data - Dati dashboard (conversations, errorHandled, ecc.)
 * @param {Array} props.percentageStateTotal - Array per le barre percentuali
 * @param {Object} props.handledPercentage - { totalHandled, totalError }
 * @returns {JSX.Element}
 */
export function StatisticsDetailGrid({ data, percentageStateTotal, handledPercentage }) {
  return (
    <div className="stats-detail-grid">
      <StatisticsCard
        variant="elaborated"
        title={t.stCardElaborate}
        countLabel={t.stDettagliElaborate}
        countValue={handledPercentage?.totalHandled}
        totalCount={data?.conversations?.length}
        data={data}
        percentageStateTotal={percentageStateTotal}
        filterMain={LABEL_STATISTICS.filter((item) => item.label === 'elaborated')}
        filterDetails={LABEL_STATISTICS.filter((item) => !item.main && !item.error)}
      />

      <StatisticsCard
        variant="handled"
        title={t.stCardConsegnateGestioneManuale}
        countLabel={t.stDettagliInoltrate}
        countValue={data?.errorHandled?.length}
        totalCount={data?.conversations?.length}
        data={data}
        percentageStateTotal={percentageStateTotal}
        filterMain={LABEL_STATISTICS.filter((item) => item.label === 'errorHandled')}
        filterDetails={[]}
        showDetailsComponent
        detailsComponent={<DetailsErrorHandled errorHandled={data?.errorHandled} />}
      />

      <StatisticsCard
        variant="errors"
        title={t.stCardEscluseErrori}
        countLabel={t.stDettagliErrori}
        countValue={handledPercentage?.totalError}
        totalCount={data?.conversations?.length}
        data={data}
        percentageStateTotal={percentageStateTotal}
        filterMain={LABEL_STATISTICS.filter((item) => item.label === 'errorTotal')}
        filterDetails={LABEL_STATISTICS.filter(
          (item) => item.label === 'realError' || item.label === 'noraIsExcluded'
        )}
      />
    </div>
  )
}
